export const creditCardExpirationRegexp: RegExp = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/i;
